import React, { useState, useEffect } from "react";
import { Button, FormControl, TextField } from "@material-ui/core";
import "../../../styles/banner.scss";
import baseUrl from "../../config/config";
import { Link } from "react-scroll";
import Modalpopup from "../../pages/Modalpopup/Modalpopup";
import CustomDrawer from "../../common/CustomDrawer/CustomDrawer";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import Modalpopupcalquemarket from "../../landing/Modalpopups/Modalpopupcalquemarket";
import { useFormik } from "formik";
import { useGAEventsTracker } from "../../../util/gtag";
import Grid from "@material-ui/core/Grid";
import { useHistory } from "react-router-dom";
// import Chatbot from "../../common/chatbot/Chatbot";

export default function NewBanner(props) {
  const GAEventTracker = useGAEventsTracker(window.location.pathname);
  const GAEventTrackerGetStarted = useGAEventsTracker(
    window.location.pathname + "/Get Started"
  );
  const GAEventTrackerContactUs = useGAEventsTracker(
    window.location.pathname + "/Contact Us"
  );
  const [openSubmit, setOpenSubmit] = React.useState(false);
  const [openCalque, setOpenCalque] = useState(false);
  const [detail, setDetail] = React.useState("");
  const [validateUserInfo, setValidateUserInfo] = useState(false);
  const [severity_type, setSeverityType] = React.useState("");
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [errorsOut, seterrorsOut] = useState();
  const [openFailure, setOpenFailure] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [address, setAddress] = useState("");
  const [itemstype, setItemstype] = useState([]);
  const [gmapErr, setGmapErr] = useState(false);
  const history = useHistory();

  // useEffect(() => {
  //     const pathName = window.location.pathname; // Get current pathname
  //     if (pathName.includes('questionnaire')) {
  //         // props?.setCDrawerHome(true); // Set to true if the page includes "questionnaire"
  //     } else {
  //       // props?.setCDrawerHome(false); // Set to false for other paths
  //     }

  //     // Prevent back button navigation on questionnaire page
  //     window.history.pushState(null, null, window.location.href);
  //     window.onpopstate = function (event) {
  //         window.history.go(1); // Stay on the current page if the user hits the back button
  //     };
  // }, []);

  useEffect(() => {
    if (props?.partner?.url_path === "c2") {
      const h2Tags = document.querySelectorAll("h2");
      const h3Tags = document.querySelectorAll("h3");
      const h4Tags = document.querySelectorAll("h4");
      const h6Tags = document.querySelectorAll("h6");
      const pTags = document.querySelectorAll("p");
      const liTags = document.querySelectorAll("li");
      const spanTags = document.querySelectorAll("span");
      const a = document.querySelectorAll("a");
      h2Tags.forEach((h2) => {
        h2.classList.add("ftpolar-semibold");
      });
      h3Tags.forEach((h3) => {
        h3.classList.add("ftpolar-light");
      });
      h4Tags.forEach((h4) => {
        h4.classList.add("ftpolar-semibold");
      });
      h6Tags.forEach((h6) => {
        h6.classList.add("ftpolar-semibold");
      });
      pTags.forEach((p) => {
        p.classList.add("ftpolar-light");
      });
      liTags.forEach((li) => {
        li.classList.add("ftpolar-light");
      });
      spanTags.forEach((span) => {
        span.classList.add("ftpolar-light");
      });
      a.forEach((a) => {
        a.classList.add("ftpolar-light");
      });
    }
  }, [props?.partner?.url_path]);

  const handleClose1 = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };
  const vertical = "top";
  const horizontal = "center";
  const handleClickOpen2 = () => {
    setOpenSubmit(!openSubmit);
  };
  const handleZipCode = () => {
    props.setValidateControl(true);
    props.setDisplayError(true);
    let postData = {
      zip_code: props.values.property_address
        ? props.values.property_address.zip_code
        : null,
    };
    let authorise = process.env.REACT_APP_API_KEY;
    fetch(`${baseUrl.postData}validate-zipcode/`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `${authorise}`,
        "Content-Type": "application/json",
        "Accept-Encoding": "gzip, deflate",
      },
      body: JSON.stringify(postData),
    })
      .then(async (response) => {
        const results = await response.json();
        if (response.status === 201 || response.status === 200) {
          props.GAtimer();
          props.GAtimerFinish();
          if (results.is_operating_area === false) {
            setOpenCalque(true);
            props && props.setErrDisplay(false);
          } else {
            setOpenCalque(false);
            props.drawerHandleOpen();
            props.handleReset();
            props && props.setErrDisplay(false);
          }
          if (
            Object.keys(props.errors).length !== 0 &&
            props.errors.property_type == undefined &&
            props.errors.street_address == undefined
          ) {
            GAEventTracker("UserEnteredQuestionnaire", 1);
          }
        } else {
          setOpenCalque(false);
          props && props.setErrDisplay(false);
          setGmapErr(results.zip_code[0]);
        }
      })
      .catch((error) => {});
  };
  const handlePopupSubmit = (event) => {
    setValidateUserInfo(true);
    if (!event.detail || event.detail == 1) {
      return true;
    } else {
      event.preventDefault();
    }
  };
  const handleClickOpener = () => {
    setOpenCalque(!openCalque);
  };
  const onSubmit = (values) => {
    var postUserQue = {
      first_name: values.first_name,
      last_name: values.last_name,
      email: values.email,
      location: props.values && props.values.property_address.street_address,
      partner_id: props?.partner?.partner_id ? props.partner.partner_id : null,
    };
    let authorise = process.env.REACT_APP_API_KEY;
    fetch(`${baseUrl.postData}email-for-validate-zipcode/`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `${authorise}`,
        "Content-Type": "application/json",
        "Accept-Encoding": "gzip, deflate",
      },
      body: JSON.stringify(postUserQue),
    })
      .then(async (response) => {
        const results = await response.json();
        if (response.status === 201 || response.status === 200) {
          setOpenSnackbar(true);
          setDetail(results.message);
          setSeverityType("success");
          setOpenSuccess(!openSuccess);
          setOpenSubmit(false);
          setValidateUserInfo(false);
          formik.setFieldValue("first_name", "");
          formik.setFieldValue("last_name", "");
          formik.setFieldValue("email", "");
          formik.setFieldValue("location", "");
          setOpenCalque(false);
        } else {
          if (results.detail) {
            setOpenSnackbar(true);
            setDetail(results.message);
            setSeverityType("error");
            setOpenFailure(!openFailure);
            setOpenSubmit(false);
            formik.setFieldValue("first_name", "");
            formik.setFieldValue("last_name", "");
            formik.setFieldValue("email", "");
            formik.setFieldValue("user_question", "");
            await sleep(2000);
          } else {
            setSeverityType("error");
          }
        }
      })
      .catch((error) => {
        setDetail("Something Went Wrong!");
        setSeverityType("error");
        setOpenSnackbar(true);
        setOpenSubmit(false);
      });
  };
  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    location: "",
  };
  const validate = (values) => {
    let errors = {};

    if (values.first_name === "") {
      errors.first_name = "Please enter first name";
    }
    if (values.last_name === "") {
      errors.last_name = "Please enter last name";
    }
    if (values.email === "") {
      errors.email = "Please provide a valid Email Address";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Please provide a valid Email Address";
    }

    return errors;
  };
  const formik = useFormik({
    initialValues,
    onSubmit,
    validate,
  });

  useEffect(() => {
    let isMounted = true;
    setTimeout(() => {
      if (isMounted) {
        seterrorsOut(props.errors);
      }
    });
    return () => {
      isMounted = false;
    };
  }, [props.errors]);

  useEffect(() => {
    props.setSubmitSuccess(true);
  }, [props]);

  useEffect(() => {
    if (openSnackbar === true) {
      setTimeout(() => {
        setOpenSnackbar(false);
      }, 2000);
    }
  }, [openSnackbar]);

  // useEffect(() => {
  //   let isMounted = true;
  //   fetch(`${baseUrl.baseUrl}get-property-type/`, {
  //     headers: {
  //       Authorization: `${process.env.REACT_APP_API_KEY}`,
  //       "Accept-Encoding": "gzip, deflate",
  //     },
  //   })
  //     .then(async (response) => {
  //       const result = await response.json();
  //       if (response.status === 201 || response.status === 200) {
  //         if (isMounted) {
  //           setItemstype(result);
  //         }
  //       } else if (response.status === 403) {
  //         localStorage.setItem("access_token", "");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("error message", error);
  //     });
  //   return () => {
  //     isMounted = false;
  //   };
  // }, []);

  const handleGetStart = () => {
    // Get the current URL
    const currentUrl = window.location.pathname;
    // Check if the URL ends with a slash, then append '/questionnaire'
    const newUrl = currentUrl.endsWith("/")
      ? `${currentUrl}questionnaire`
      : `${currentUrl}/questionnaire`;
    // Use pushState to change the URL without reloading the page
    // window.history.pushState(null, "", newUrl);
    history.push(newUrl);
    props.setCDrawerHome(true);
    // window.location.reload();
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function Contactus() {
    return (
      <>
        <div className="container-fluid m-0 top-padding-small bottom-padding-main px-md-5">
          <div className="row px-md-5">
            <div className="col-12 px-md-5">
              <div className="justify-content-md-between align-items-md-center">
                <h3 className="headerfont">Contact Us</h3>
                <div className="contentfonthead">
                  To speak with a Calque representative, call
                </div>
                <div className="contentfont">
                  <a
                    className="tel"
                    href={`tel:${props?.contactGlobal?.application_config_value}`}
                    style={{ cursor: "pointer", color: "black" }}
                  >
                    <b>{props?.contactGlobal?.application_config_value}</b>
                  </a>
                </div>
                <div className="contentfonthead">Or send an email to</div>
                <div className="contentfont">
                  <a
                    className="mailto"
                    href={`mailto:${props?.emailGlobal?.application_config_value}`}
                    style={{ cursor: "pointer", color: "black" }}
                  >
                    <b>{props?.emailGlobal?.application_config_value}</b>
                  </a>
                </div>
                <div className="contentfonthead">Our address is</div>
                <div className="contentfont">
                  <b>
                    <p className="contactAddress">
                      {props?.addressGlobal?.application_config_value}
                    </p>
                  </b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  function calqueMarket() {
    return (
      <>
        <form onSubmit={formik.handleSubmit} noValidate>
          <div className="container d-none d-md-block">
            <div className="row">
              <div className="col-6 p-5">
                <h2>WE'RE WORKING ON IT!</h2>
                <p className="pt-4">
                  Thanks for your interest in{" "}
                  {props?.partner?.partner_program_name}! Calque is not
                  currently operating in your market, but we’re expanding fast.
                </p>
                <p>
                  If you give us your name and email, we will reach out once we
                  arrive.
                </p>
              </div>
              <div className="col-6">
                <div className="col-12 top-padding-small py-3">
                  <h6>Name</h6>
                  <div className="row">
                    <div className="col-6">
                      <TextField
                        className="w-100"
                        placeholder="First Name"
                        type="text"
                        name="first_name"
                        onChange={formik.handleChange}
                        value={formik.values.first_name}
                        variant="outlined"
                      />
                      {validateUserInfo === true ? (
                        formik.errors.first_name ? (
                          <div className="error-msg">
                            {formik.errors.first_name}
                          </div>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="col-6">
                      <TextField
                        className="w-100"
                        placeholder="Last Name"
                        name="last_name"
                        type="text"
                        onChange={formik.handleChange}
                        value={formik.values.last_name}
                        variant="outlined"
                      />
                      {validateUserInfo === true ? (
                        formik.errors.last_name ? (
                          <div className="error-msg">
                            {formik.errors.last_name}
                          </div>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12 py-3">
                  <h6>Email Address</h6>
                  <div className="row">
                    <div className="col-12">
                      <TextField
                        placeholder="Email"
                        variant="outlined"
                        name="email"
                        type="text"
                        onChange={formik.handleChange}
                        value={formik.values.email}
                        className="w-100"
                      />
                      {validateUserInfo === true ? (
                        formik.errors.email ? (
                          <div className="error-msg">{formik.errors.email}</div>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12 py-3">
                  <div className="row">
                    <div className="col-12">
                      <Button
                        disableelevation="true"
                        type="submit"
                        variant="contained"
                        color="inherit"
                        className="w-100"
                        style={{ height: "50px", backgroundColor: "#FBC04E" }}
                        onClick={(e) => {
                          GAEventTracker("Submit Now(Non Operating Area)");
                          handlePopupSubmit(e);
                        }}
                      >
                        Submit Now
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container d-block d-md-none">
            <div>
              <div className="p-2">
                <h2>WE'RE WORKING ON IT!</h2>
                <p className="pt-4">
                  Thanks for your interest in{" "}
                  {props?.partner?.partner_program_name}! Calque is not
                  currently operating in your market, but we’re expanding fast.
                </p>
                <p>
                  If you give us your name and email, we will reach out once we
                  arrive.
                </p>
              </div>
              <div>
                <div className="top-padding-small py-3">
                  <h6>Name</h6>
                  <div>
                    <div>
                      <TextField
                        className="w-100"
                        placeholder="First Name"
                        type="text"
                        name="first_name"
                        onChange={formik.handleChange}
                        value={formik.values.first_name}
                        variant="outlined"
                      />
                      {validateUserInfo === true ? (
                        formik.errors.first_name ? (
                          <div className="error-msg">
                            {formik.errors.first_name}
                          </div>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="pt-3">
                    <div>
                      <TextField
                        className="w-100"
                        placeholder="Last Name"
                        name="last_name"
                        type="text"
                        onChange={formik.handleChange}
                        value={formik.values.last_name}
                        variant="outlined"
                      />
                      {validateUserInfo === true ? (
                        formik.errors.last_name ? (
                          <div className="error-msg">
                            {formik.errors.last_name}
                          </div>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="py-3">
                  <h6>Email Address</h6>
                  <div>
                    <div>
                      <TextField
                        placeholder="Email"
                        variant="outlined"
                        name="email"
                        type="text"
                        onChange={formik.handleChange}
                        value={formik.values.email}
                        className="w-100"
                      />
                      {validateUserInfo === true ? (
                        formik.errors.email ? (
                          <div className="error-msg">{formik.errors.email}</div>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="py-3">
                  <div>
                    <Button
                      disableelevation="true"
                      type="submit"
                      variant="contained"
                      color="inherit"
                      className="w-100"
                      style={{ height: "50px", backgroundColor: "#FBC04E" }}
                      onClick={(e) => {
                        GAEventTracker("Submit Now(Non Operating Area)");
                        handlePopupSubmit(e);
                      }}
                    >
                      Submit Now
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </>
    );
  }

  return (
    <div className="inter">
      <div className="col-12">
        <div className="row">
          <div
            className="main-banner-img-container col-md-12 col-sm-12"
            style={{
              backgroundImage: "url('/assets/images/new_temp_banner_bg.webp')",
            }}
          >
            <div>
              <h2
                className={`new-main-heading align-start inter banner-main-heading ${props?.partner?.url_path ==='megastar' ? 'custom-megastar-heading' :''}`}
                style={{
                  fontWeight: "bold",
                  color: "#fff",
                  fontSize:props?.partner?.url_path ==='megastar' ? '60px': "80px",
                  marginBottom: "30px",
                }}
              >
                {props?.partner?.url_path === 'megastar' ? `Megastar's 7-Day`:'A Better Way To'}
                <br />
                <span style={{ color: "#FBC04E" }}>{props?.partner?.url_path === 'megastar' ? 'Non-Contingent Buyer Program': 'Buy-Before-You-Sell'}</span>
              </h2>
            </div>
            <div>
              <Button
                variant="contained"
                disableelevation="true"
                color="inherit"
                type={props.submitSuccess === true ? "submit" : "button"}
                className="get-started-btn inter"
                style={{
                  height: "54px",
                  color: "white",
                  backgroundColor: `${
                    props.partner.secondary_color
                      ? props.partner.secondary_color
                      : "#2A83C2"
                  }`,
                }}
                onClick={(e) => {
                  GAEventTrackerGetStarted("Get started", 1);
                  handleGetStart();
                }}
              >
                Submit an Application
              </Button>
            </div>
            <div>
              <p
                className="text-start m-0"
                style={{ fontSize: "18px", color: "#fff" }}
              >
                *It's free and only takes 5 minutes!
              </p>
            </div>
            {/* <div>{props?.partner?.url_path === "alcova" && <Chatbot />}</div> */}
          </div>
        </div>
      </div>
      <div style={{ padding: "80px 0px", width: "100%" }}>
        <div style={{ textAlign: "center" }}>
          <h2 className="new-heading inter" style={{ fontWeight: "700" }}>
            Experience More When You{" "}
            <span
              style={{
                color: "#4594CB",
              }}
            >
              Buy-Before-You-Sell
            </span>
          </h2>
        </div>
        <div style={{ padding: "20px", alignSelf: "center" }}>
          <Grid container spacing={2}>
            {[...Array(3)].map((_, i) => (
              <Grid key={i} item md={4} sm={4} xs={12}>
                <div
                  className="banner-card"
                  style={{
                    backgroundColor: props.partner.primary_color || "#2A83C2",
                    padding: "25px 20px",
                  }}
                >
                  <img
                    src={`assets/images/${
                      ["growth", "online_business", "rocket"][i]
                    }.webp`}
                    alt="icon"
                    className="banner-icon"
                  />
                  <h4
                    className="inter card-heading"
                    style={{ fontWeight: "bold" }}
                  >
                    {["More Success", "More Convenience", "More Confidence"][i]}
                  </h4>
                  <p className="p-2 m-0 card-text">
                    {
                      [
                        "Make offers with no home sale contingency that are more likely to win.",
                        "Buy your dream home now. Sell your current home when you’re ready.",
                        "List your home for a competitive price, and rest easy with a guaranteed backup offer from Calque.",
                      ][i]
                    }
                  </p>
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleClose1}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert onClose={handleClose1} severity={severity_type}>
          <div className="error" style={{ color: "white" }}>
            <span>{detail}</span>
          </div>
        </Alert>
      </Snackbar>
      <Modalpopup
        open={openSubmit}
        handleClickOpen={handleClickOpen2}
        contact={Contactus()}
      />
      <Modalpopupcalquemarket
        open={openCalque}
        handleClickOpener={handleClickOpener}
        contactData={calqueMarket()}
      />
      {props.cdrawerHome === false && (
        <CustomDrawer
          cdrawer={props.cdrawer}
          loader={props.loader}
          handleProgress={props.handleProgress}
          formik={props.formik}
          {...props}
          handleNext={props.handleNext}
          handleChange={props.handleChange}
          values={props.values}
          getEstimateButton={props.getEstimateButton}
          ValidateFinalError={props.ValidateFinalError}
          gaUserNotAnswered={props.gaUserNotAnswered}
          setGaUserNotAnswered={props.setGaUserNotAnswered}
          GAtimerFinish={props.GAtimerFinish}
          setCaptchaValue={props.setCaptchaValue}
          captchaValue={props.captchaValue}
          validateDisplay10={props.validateDisplay10}
        />
      )}
    </div>
  );
}
